import { getCurrentServer } from "../utils/globalData";
import { useMainStore } from "~/composables/store"; 
import { get } from "lodash-es";
export default defineNuxtPlugin((nuxtApp) => {
    const store = useMainStore();
    const headers = useRequestHeaders();
    const getNowCurrentPageConfigFn = () => {
      const currentServer = getCurrentServer(headers);
      if(store.$state.storeInfoDataMap[currentServer]){
        return get(store.$state.storeInfoDataMap[currentServer],'storePageInfo');
      }
      return null;
    }
    
    // 提供全局访问
    return {
      provide: {
        getNowCurrentPageConfig: {
          get: getNowCurrentPageConfigFn,
          value: getNowCurrentPageConfigFn() // 初始值
        }
      }
    }
  })